/** Read Meta browser cookies for CAPI match quality (not hashed server-side). */
export function getMetaCookies(): { fbp?: string; fbc?: string } {
  if (typeof document === 'undefined') {
    return {};
  }
  const out: { fbp?: string; fbc?: string } = {};
  for (const part of document.cookie.split(';')) {
    const trimmed = part.trim();
    const eq = trimmed.indexOf('=');
    if (eq < 0) continue;
    const name = trimmed.slice(0, eq);
    const value = decodeURIComponent(trimmed.slice(eq + 1));
    if (name === '_fbp' && value) out.fbp = value;
    if (name === '_fbc' && value) out.fbc = value;
  }
  return out;
}
